import _ from "lodash";
import {URL_API_DYNAMIC_FORM_ELEMENTS, URL_API_DYNAMIC_FORM_ELEMENTS_UPDATE, URL_API_DYNAMIC_FORM_TEMPLATE_ADD,
  URL_API_DYNAMIC_FORM_TEMPLATE_EDIT,  URL_API_DYNAMIC_FORM_TEMPLATE_UNMAPPED, URL_API_DYNAMIC_FORM_TEMPLATE_MAP,
  URL_API_DYNAMIC_FORM_TEMPLATE_MAPPED_LIST,URL_API_DYNAMIC_FORM_TEMPLATE_TEMPLATE_NAME_LIST, URL_API_DYNAMIC_FORM_TEMPLATE_MAP_EXIST,
  URL_API_DYNAMIC_FORM_TEMPLATE_AUDIT_LIST, URL_API_DYNAMIC_FORM_TEMPLATE_DELETE, URL_API_DYNAMIC_FORM_TEMPLATE_RE_ASSIGN} from '../apiHitFile';
export function FormElementAction(){
  return (dispatch, getState) => {  
    dispatch(Pending())  
    let headers = new Headers()
   //headers.append('Access-Control-Allow-Origin', '*')
    fetch(URL_API_DYNAMIC_FORM_ELEMENTS, {
        method: 'GET',
        headers : headers,
    })
     .then(res=>res.json())      
     .then(json => {        
      dispatch(FormElementSuceess(json))  
     })
      .catch(error => {                  
       dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:error.message, isPending:false})     
      })
    }
}
export function Pending(){
  return{
    type:"FORM_PENDING",
    isPending:true
  }
}
export function FormElementSuceess(data){
  if(!_.isEmpty(data) && data.status === 1001){
  return {
      type: "FORM_ELEMENTS_ACTION",
      payload: data.value,
      isPending:false
  }
 }else{
   return{
    type: "FORM_TEMPLATE_UPDATEERROR", 
    showerror:true,
    errmessage:data.message,
    isPending:false
   }
 }
}
export function FormElementAdd(prop, obj){
  return{
   type: 'FORM_ELEMENTS_ACTION_ADD',
   prop, obj
  }
 
}
export function FormElementEdit(prop, object, data, i){
  return{
   type: 'FORM_ELEMENTS_ACTION_EDIT',
   prop, object, data, i
  }
 
}
export function FormElementDelete(prop, obj){
  return{
   type: 'FORM_ELEMENTS_ACTION_DELETE',
   prop, obj
  } 
}
export function FormElementActive(prop, obj){
  return{
   type: 'FORM_ELEMENTS_ACTION_ACTIVE',
   prop, obj
  } 
}
export function FormElementAdditionalFieldsEdit(prop, obj){
  return{
   type: 'FORM_ELEMENTS_ACTION_ADDITIONALFIELD_EDIT',
   prop, obj
  }
 
}
//Form elements Save Updated API
export function FormElementUpdateSave(prop){
  return (dispatch, getState) => {    
    let userName = getState().LoginReducer.loginAction.userName;
    let obj={"formElements":prop, userName}
    dispatch(Pending())  
    let headers = new Headers()
    fetch(URL_API_DYNAMIC_FORM_ELEMENTS_UPDATE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((data) =>(dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:'Saved successfully', isPending:false})))
      .catch((err)=> (dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:err.message, isPending:false})))
  }
}

//Form Template UnMapeed List API
export function FormTemplateAction(){
  return (dispatch, getState) => {
    dispatch(Pending())  
    let headers = new Headers()
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_UNMAPPED, {
      method: 'GET',
      headers : headers,      
    })
     .then(res=>res.json())
     .then(json => {
      dispatch(FormTemplateSuceess(json))
     })
      .catch(err=> {
        dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:err.message, isPending:false})                      
      })
    } 
}
export function FormTemplateSuceess(templateInventory){
  return {
    type: 'FORM_TEMPLATE_ACTION',
    payload: templateInventory.value,
    isPending:false
  }
}

// Form Template Add
export function FormTemplateActionAdd(prop, title){  
  return (dispatch, getState) => {
  dispatch(Pending())  
  let userName = getState().LoginReducer.loginAction.userName;
  let Object={
    'templateName':title,
    'templateValue': prop, 
    'status':'ACTIVE',
     userName
  } 
  let headers = new Headers()
  fetch(URL_API_DYNAMIC_FORM_TEMPLATE_ADD, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(Object)
  }).then((res) => res.json())
     .then(json => {
      dispatch(FormTemplateAddSuceess(Object))      
      dispatch(FormTemplateAction())    
      dispatch(templateNamesList())    
    })   
    .catch(error => {
      dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:error.message, isPending:false})
    })
   }
}
export function FormTemplateAddSuceess(Object){
  return{
   type: 'FORM_TEMPLATE_ACTION_ADD',
   Object,
   isPending:false
  }
}
// Form Template Edit
export function FormTemplateActionEdit(title, prop, template){  
  template.templateValue = prop  
  return (dispatch, getState) => {
    let userName = getState().LoginReducer.loginAction.userName;
    template['userName'] = userName
  dispatch(Pending())  
  let headers = new Headers()
  fetch(URL_API_DYNAMIC_FORM_TEMPLATE_EDIT, {
    method: 'POST',
    headers : headers,
    body:JSON.stringify(template)
  }).then((res) => res.json())
     .then(json => {
      if(json.status === 200 || json.status === 1001){
      dispatch(FormTemplateAction())    
      dispatch(templateNamesList())  
       dispatch(FormTemplateEditSuceess(title, prop))     
       dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:json.message, isPending:false})
      } else {
        dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:json.message, isPending:false})
      }
    })   
    .catch(error => {
      dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:error.message, isPending:false})
    })
   }
 }

 export function FormTemplateEditSuceess(title,prop){
  return{
   type: 'FORM_TEMPLATE_ACTION_EDIT',
   title, prop,
   isPending:false
  }
}
export function formTemplateMapping (obj){
  return  (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_MAP, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())      
      .then((json)=> {dispatch(formtemplateMapSuccess(json))
      })
      .catch((error) => dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:error.message}))
  }
 }

export function formtemplateMapSuccess(data){
  return {
    type: "FORM_TEMPLATE_MAP",
    mapSucess:data
 }
}
export function formtemplateMapExist(props){
  return (dispatch, getState) => {    
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_MAP_EXIST, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(props)
    }).then((res) => res.json()) 
    .then((data) => {  dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:data.message, isPending:false})  })
    .catch((error)=> { dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:error.message, isPending:false})  })
  }
}

export function templateNamesList(){
  return (dispatch, getState) => {
    let headers = new Headers()
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_TEMPLATE_NAME_LIST, {
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => {      
      dispatch(templateNamesListSuceess(json))
     })
      .catch(error => {
       console.log('error',error)
       
      })
   }
}
export function templateNamesListSuceess(nameList){
  return{
    type: 'FORM_TEMPLATE_NAMES_LIST',
    nameList: nameList.formTemplateList
   } 
}
export function MappedList(){
  return (dispatch, getState) => {
    dispatch(Pending())  
    let headers = new Headers()
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_MAPPED_LIST,{
      method: 'GET',
      headers : headers,
    })
     .then(res=>res.json())
     .then(json => {
      dispatch(formMappedSuceess(json))
     })
      .catch(error => {
      dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:error.message, isPending:false})       
      })
   }
}
export function formMappedSuceess(mappedList){ 
  if(!_.isEmpty(mappedList)){
  return{
   type: 'FORM_TEMPLATE_MAPPED_LIST',
   mappedData: mappedList.value,
   isPending:false
    } 
  }
}

// Audit Type
export function AuditTypeList(){
  return (dispatch, getState) => {
    let headers = new Headers()
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_AUDIT_LIST, {
      method: 'GET',
      headers : headers
    })
     .then(res=>res.json())
     .then(json => {
      dispatch(AuditTypeListSuceess(json))
     })
      .catch(error => {
        console.log(error)
        
      })
   }
}
export function AuditTypeListSuceess(data){
 // if(data.status === 1001 && !_.isEmpty(data.value)){
  return{
    type: 'FORM_TEMPLATE_AUDIT_TYPES',
    auditTypes:data    
   } 
 // }
}
export function formTemplateDelete(prop){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_DELETE, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res)
    .then((data) => {
      dispatch(formTemplateDeleteSuccess(prop))
      dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:"Template Deleted Successfully"})
      }) 
      .catch((err)=> {
          dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:err.message}) 
      })
  }
}

export function formTemplateDeleteSuccess(prop){
  return{
    type: 'FORM_TEMPLATE_DELETE', 
    prop   
   }
}

export function ReAssignAPI(prop){
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_DYNAMIC_FORM_TEMPLATE_RE_ASSIGN, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(prop)
    }).then((res) => res.json())
      .then((data) => {
        dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:data.message}) 
        dispatch(MappedList())        
      })
      .catch((err)=> {
          dispatch({type: "FORM_TEMPLATE_UPDATEERROR", showerror:true, errmessage:err.message})       
      })
  }
}
export function closeModalPopUp(){
  return{
    type:'FORM_ACTION_MODAL_CLOSE',
    showerror:false
  }

}





